import { getMessage } from '@tcc/i18n';

export default function setup() {
  document.title = `${getMessage('title')} | Climate FieldView`;
  return Promise.resolve(true);
}
